import { apiCreate, apiGetOne } from './ApiBaseActions';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGIN_PURGE = 'AUTH_LOGIN_PURGE';
export const API_AUTH_ROLE_SLIDE = 'API_AUTH_ROLE_SLIDE';
export const API_AUTH_INFORMATION = 'API_AUTH_INFORMATION';
export const API_AUTH_INFORMATION_SUCCESS = 'API_AUTH_INFORMATION_SUCCESS';
export const API_AUTH_REDIRECT_SAVE = 'API_AUTH_REDIRECT_SAVE';
export const API_AUTH_REDIRECT_RESET = 'API_AUTH_REDIRECT_RESET';
export const authLogout = () => ({
    payload: {},
    type: AUTH_LOGOUT,
});
export const apiAuthInformation = (meta) => apiGetOne(API_AUTH_INFORMATION, '/auth/information', meta);
export const apiAuthRoleSlide = (data, meta) => apiCreate(API_AUTH_ROLE_SLIDE, '/auth/role/slide', data, meta);
export const authRedirectSave = (pathname) => ({
    payload: {
        pathname,
    },
    type: API_AUTH_REDIRECT_SAVE,
});
